interface FlightAirports {
  originIATA: string;
  destinationIATA: string;
}

interface FlightNumberAndDate {
  flightNumber: string;
  departureDate: string;
}

export interface CaseDataToken {
  flightData: FlightAirports[] | FlightNumberAndDate[];
  customerData?: any;
  address?: any;
}

export const trimMimeType = (base64String: string) => {
  return base64String.split(",")[1];
};

export const getFileSizeByBase64String = (base64String: string) => {
  const base64EncodedSize = base64String.length;
  return 3 * Math.floor(base64EncodedSize / 4);
};

export const deserializeBase64StringJSON = (
  base64string: string
): Object | null => {
  if (base64string) {
    const json = Buffer.from(base64string, "base64").toString("utf-8");
    try {
      const data: {} = JSON.parse(json);
      return data;
    } catch (error: any) {
      console.error(
        "Error occurred while deserializing JSON from base64 string: ",
        error
      );
      return null;
    }
  } else {
    return null;
  }
};

export const deserializeCaseDataToken = (
  caseDataToken: string
): CaseDataToken | null => {
  const deserializedTokenData: CaseDataToken = deserializeBase64StringJSON(
    caseDataToken
  ) as CaseDataToken;
  // Later there will be more data e.g. customer address etc.
  if (deserializedTokenData) {
    const { flightData } = deserializedTokenData;
    return { flightData };
  } else {
    return null;
  }
};
